import { dialonceSmallLogoUrl } from "../constants";
import type { ChatbotParams } from "../schemas/dochatConfig";

export const chatbotParamsDefaultValues: Required<
  Pick<
    ChatbotParams,
    | "availableLocales"
    | "disclaimerActivate"
    | "theme"
    | "buttons"
    | "enableCloseButton"
    | "enableRefreshButton"
    | "enableCopyMessageButton"
    | "lastMessageScrollPosition"
    | "logoDataUri"
    | "logoType"
    | "fullLogoHeight"
    | "noUserInput"
    | "onlyLastMessage"
    | "placeholder"
    | "rasaContext"
    | "simulateStreaming"
    | "showPoweredByDialonce"
    | "sttEnabled"
    | "title"
    | "subTitle"
    | "disclaimerText"
    | "ttsEnabled"
    | "scrollOnTopOfUserMessages"
    | "noHeader"
    | "disclaimerMessagePlacement"
    | "fullSize"
    | "motionEnabled"
  >
> = {
  availableLocales: null,
  disclaimerActivate: false,
  theme: null,
  buttons: {
    position: "default",
    backButtonPosition: "actions",
    showOnlyLast: false,
  },
  enableCloseButton: false,
  enableRefreshButton: false,
  enableCopyMessageButton: false,
  showPoweredByDialonce: true,
  lastMessageScrollPosition: "bottom",
  logoDataUri: dialonceSmallLogoUrl,
  logoType: "symbol",
  fullLogoHeight: 32,
  noUserInput: false,
  onlyLastMessage: false,
  placeholder: "How can I help you?",
  rasaContext: {},
  simulateStreaming: false,
  sttEnabled: false,
  title: "Client service",
  subTitle: "",
  disclaimerText: "",
  ttsEnabled: false,
  scrollOnTopOfUserMessages: false,
  noHeader: false,
  disclaimerMessagePlacement: "settings",
  fullSize: {},
  motionEnabled: true,
};
